import React, { useState, useEffect } from "react";
import Select from "react-select";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineDelete } from "react-icons/ai";
import { FiFilter, FiEdit } from "react-icons/fi";
import { FcRefresh } from "react-icons/fc";
import { RiFilePaperLine } from "react-icons/ri";
import { BiCommentError } from "react-icons/bi";
import { ToastContainer } from "react-toastify";
import DashLayout from "../../layouts/DashLayout";
import Table from "../../components/Table";
import Overlay from "../../components/Overlay";
import { style, color } from "../../styles/Style";
import Action from "../../components/ProductAction";
import { Insurances, beneficiaries } from "../../utils/DataSource";
import {
  deleteStock,
  getStockById,
  updateStock,
} from "../../store/actions/StoreActions";
import {
  addnewProduct,
  deleteProduct,
  getProducts,
  updateProduct,
} from "../../store/actions/StockProductsActions";
import { changeFromTimeStamp } from "../../utils/changeFromTimeStamp";
import changeMonthToText from "../../utils/ChangeMonthToText";

import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { getUsers } from "../../store/actions/UsersActions";
import ContentLoader from "react-content-loader";
import { currentDate } from "../../utils/currentDate";
import DownloadBtn from "../../components/DownloadBtn";

function ViewStock() {
  const dispatch = useDispatch();
  const stock = useSelector((state) => state.stockState.stock);

  const stockProducts = useSelector((state) => state.productsState.products);
  const users = useSelector((state) => state.usersState.users);
  const loaders = useSelector((state) => state.loadersState);

  const [editedStock, setEditedStock] = useState({
    createdAt: "",
    description: "",
    owners: [],
    stockName: "",
  });

  const { stockId } = useParams();
  const selectedStoreId = stockId;

  const products = stockProducts?.filter(
    (ourProduct) => ourProduct.stockType[0].id === stock.id
  );

  const [product, setProduct] = useState({
    amount: "",
    amountQuantityMeasurement: "",
    expireDate: "",
    status: "STORED",
    stockTypesIds: [{ idValue: selectedStoreId }],
    storedAt: "",
    storedToolName: "",
  });
  const [openUpperTab, setOpenUpperTab] = useState(1);
  // overlays
  const [addProductOverlay, setAddProductOverlay] = useState(0);
  function productOverlayController() {
    setAddProductOverlay(!addProductOverlay);
    setProduct({
      id: "",
      amount: "",
      amountQuantityMeasurement: "",
      expireDate: "",
      status: "STORED",
      stockTypesIds: [{ idValue: selectedStoreId }],
      storedAt: "",
      storedToolName: "",
    });
  }

  const [filterBenOverlay, setFilterBeneOverlay] = useState(0);
  function filterOverlayController() {
    setFilterBeneOverlay(!filterBenOverlay);
  }
  const [editProductOverlay, setEditProductOverlay] = useState(0);
  function editProductOverlayController(passedProduct) {
    setEditProductOverlay(!editProductOverlay);
    setProduct({
      id: passedProduct.id,
      amount: passedProduct.amount,
      amountQuantityMeasurement: passedProduct.amountQuantityMeasurement,
      expireDate: changeFromTimeStamp(passedProduct.expireDate),
      status: passedProduct.status,
      stockTypesIds: [{ idValue: stock.id }],
      storedAt: changeFromTimeStamp(passedProduct.storedAt),
      storedToolName: passedProduct.storedToolName,
    });
  }

  const [editStock, setEditStock] = useState(0);
  function editStockController(passedStock) {
    setEditStock(!editStock);
    setEditedStock({
      id: passedStock.id,
      createdAt: passedStock.createdAt,
      description: passedStock.description,
      owners: [],
      stockName: passedStock.stockName,
    });
  }
  const [addStock, setAddStock] = useState(0);
  function AddStockController() {
    setAddStock(!addStock);
  }
  const [filterStockOverlay, setFilterStockOverlay] = useState(0);
  function StockFilterOverlayController() {
    setFilterStockOverlay(!filterStockOverlay);
  }

  // for insurance table
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "Property",
        accessor: "property",
      },
      {
        Header: "Quantity",
        accessor: "amount",
      },
      {
        Header: "StoredAt",
        accessor: "time",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  // transform marks data
  let [loadedItems, setLoadedItems] = useState([]);
  useEffect(() => {
    setLoadedItems([]);
    for (let i = 0; i < products?.length; i++) {
      const item = {
        count: i + 1,
        id: products[i].id,
        property: products[i].storedToolName,
        amount: ` ${products[i].amount} ${products[i].amountQuantityMeasurement}`,
        time: changeMonthToText(products[i].storedAt),
        status: (
          <div className="py-1 px-2 rounded text-indigo-500 bg-indigo-50 font-normal fit-content">
            {products[i].status}
          </div>
        ),
        action: (
          <Action
            editAction={() => {
              editProductOverlayController(products[i]);
            }}
            deleteAction={() => {
              handleDelete(products[i].id);
            }}
          />
        ),
      };

      setLoadedItems((loadedItems) => [...loadedItems, item]);

      if (
        loaders.storedProduct.deletingAction &&
        loaders.storedProduct.deletingAction.deleting
      ) {
        const currentProducts = loadedItems;
        const newData = currentProducts.map((productInStock) =>
          productInStock.id === loaders.storedProduct.deletingAction.id
            ? {
              ...productInStock,
              action: (
                <div className="spinner red-spinner m-auto">
                  <div className="bounce1"></div>
                  <div className="bounce2"></div>
                  <div className="bounce3"></div>
                </div>
              ),
            }
            : productInStock
        );
        setLoadedItems(newData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockProducts, loaders.storedProduct.deletingAction]);

  let [loadingStoredProducts, setLoadingStoredProducts] = useState([]);

  useEffect(() => {
    setLoadingStoredProducts([]);
    for (let i = 0; i < 5; i++) {
      const item = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        property: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        amount: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        time: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        status: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
      };

      setLoadingStoredProducts((loadingStoredProducts) => [
        ...loadingStoredProducts,
        item,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaders.storedProduct.fetchingLoaders]);

  // handle delete
  const handleDelete = (id) => {
    dispatch(deleteProduct(id));
  };
  useEffect(() => {
    dispatch(getStockById(selectedStoreId));    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getProducts());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // handle stock update
  const handleStockUpdate = (e) => {
    e.preventDefault();
    const id = stock.id;
    const updatedStore = {
      id: editedStock.id,
      createdAt: editedStock.createdAt,
      description: editedStock.description,
      owners: editedStock.owners,
      stockName: editedStock.stockName,
    };
    dispatch(updateStock(updatedStore, id, closeStockAfterUpdating));
  };
  const history = useHistory();
  // handle delete
  const handleDeleteStock = (id) => {
    dispatch(deleteStock(id, redirectAfterDelete));
  };

  function redirectAfterDelete() {
    history.push("/services/stock");
  }
  // owners select option
  const stocksOwnersOption = [];
  for (let i = 0; i < users.length; i++) {
    const type = {
      value: users[i].id,
      label: users[i].username,
    };

    stocksOwnersOption.push(type);
  }
  const [selectedValue, setSelectedValue] = useState([]);

  // owners select option
  const transormOwners = [];
  for (let i = 0; i < selectedValue.length; i++) {
    const type = {
      idValue: selectedValue[i],
    };

    transormOwners.push(type);
  }

  const handleChange = (e) => {
    setSelectedValue(Array.isArray(e) ? e.map((x) => x.value) : []);
    return [stock.owners, ...transormOwners];
  };

  useEffect(() => {
    dispatch(getUsers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // handle product submit
  const handleProductSubmit = (e) => {
    e.preventDefault();
    if (product.id) {
      const id = product.id;
      const updatedProduct = {
        id: product.id,
        amount: product.amount,
        amountQuantityMeasurement: product.amountQuantityMeasurement,
        expireDate: product.expireDate,
        status: product.status,
        stockTypesIds: [{ idValue: stock.id }],
        storedAt: new Date(),
        storedToolName: product.storedToolName,
      };
      dispatch(updateProduct(updatedProduct, id, closeProductAfterUpdating));
    } else {
      const newProduct = {
        ...product,
        storedAt: new Date(),
      };
      dispatch(addnewProduct(newProduct, closeProductFormAfterAdding));
    }
    setProduct({
      id: "",
    });
  };

  // closing product after cu
  function closeProductFormAfterAdding() {
    productOverlayController();
    setProduct({
      id: "",
      amount: "",
      amountQuantityMeasurement: "",
      expireDate: "",
      status: "STORED",
      stockTypesIds: [{ idValue: selectedStoreId }],
      storedAt: "",
      storedToolName: "",
    });
  }

  function closeProductAfterUpdating() {
    editProductOverlayController({
      id: "",
      amount: "",
      amountQuantityMeasurement: "",
      expireDate: "",
      status: "STORED",
      stockTypesIds: [{ idValue: selectedStoreId }],
      storedAt: "",
      storedToolName: "",
    });
  }
  // closing product after u

  function closeStockAfterUpdating() {
    editStockController({
      createdAt: "",
      description: "",
      owners: [],
      stockName: "",
    });
  }
  return (
    <DashLayout>
      <div className="text-xs">
        <ToastContainer />
      </div>

      {(!loaders.store.loadingOne && !stock.id) |
        loaders.store.loadingOneFailedMsg ? (
        <div
          className={
            !loaders.store.loadingOneFailedMsg
              ? "bg-white mx-10 h-60 flex  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold"
              : "bg-red-100 mx-10 h-60 flex text-xs rounded  text-center py-2 px-4 text-red-500 font-semibold"
          }
        >
          <div className="m-auto">
            {!loaders.store.loadingOneFailedMsg ? (
              <div className="flex-col">
                <RiFilePaperLine className="text-3xl mx-auto my-3" />{" "}
                <p>This stock is not found</p>{" "}
              </div>
            ) : (
              <div className="flex-col">
                <BiCommentError className="text-3xl mx-auto my-3" />{" "}
                <p>{loaders.store.loadingOneFailedMsg}</p>{" "}
              </div>
            )}
          </div>
        </div>
      ) : loaders.store.loadingOne ? (
        <div className="bg-white mx-10 h-60 flex">
          <div className="spinner m-auto indigo-spinner">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        </div>
      ) : (
        <div className="mx-10 bg-white">
          <div className="flex flex-col md:flex-row p-10 pt-5 pl-10 pb-0">
            <h2 className="font-semibold">
              <Link
                to="/services/stock"
                className="hover:text-indigo-500 text-indigo-300"
              >
                Stock {">"}
              </Link>{" "}
              <span className="font-normal">{stock.stockName}</span>
            </h2>
            <div className="md:m-auto mt-2 md:mr-0">
              <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400"
                    : "hidden"
                }
                onClick={() => {
                  openUpperTab === 1
                    ? productOverlayController()
                    : editStockController(stock);
                }}
              >
                <FiEdit />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "hidden"
                    : "p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400"
                }
                onClick={() => {
                  openUpperTab === 1
                    ? productOverlayController()
                    : editStockController(stock);
                }}
              >
                <FiEdit />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "hidden"
                    : "p-2 mr-2 rounded text-red-500 border border-red-500 hover:bg-red-100"
                }
                onClick={() => {
                  handleDeleteStock(selectedStoreId);
                }}
              >
                <AiOutlineDelete
                  className={
                    loaders.store.deletingAction &&
                      loaders.store.deletingAction.deleting
                      ? " refresh-loader"
                      : " "
                  }
                />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100"
                    : "hidden"
                }
                onClick={() => {
                  openUpperTab === 1
                    ? filterOverlayController()
                    : StockFilterOverlayController();
                }}
              >
                <FiFilter />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100"
                    : "hidden"
                }
                onClick={() => {
                  dispatch(getProducts());
                }}
              >
                <FcRefresh
                  className={
                    loaders.storedProduct.fetchingLoaders
                      ? " refresh-loader"
                      : " "
                  }
                />
              </button>
              {/* <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100"
                    : "hidden"
                }
              >
                <BsDownload />
              </button> */}
              <DownloadBtn
                filename={`${stock.stockName}-${changeMonthToText(currentDate())}`} table="table-to-xls"
              />
            </div>
          </div>
          {/* insurance tabs */}
          <div className="flex mt-2 flex-wrap">
            <div className="w-full">
              <ul
                className="flex mb-0 list-none flex-wrap  font-normal  flex-row w-full"
                role="tablist"
              >
                <li className="-mb-px  last:mr-0 ml-10">
                  <a
                    className={
                      "text-xs   px-5 py-1 pl-0   block leading-normal" +
                      (openUpperTab === 1
                        ? " text-white bg-indigo-500 rounded rounded-r-none border-b-2 border-" +
                        color +
                        "-500"
                        : " text-indigo-50 bg-indigo-300 border-b-2 rounded rounded-r-none border-indigo-300")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenUpperTab(1);
                    }}
                    data-toggle="tab"
                    href="#link1"
                    role="tablist"
                  >
                    <i className="fas fa-space-shuttle text-base mr-1"></i>{" "}
                    Property
                  </a>
                </li>
                <li className="-mb-px  last:mr-0">
                  <a
                    className={
                      "text-xs   px-5 py-1 pl-0  block leading-normal " +
                      (openUpperTab === 2
                        ? " text-white bg-indigo-500 rounded rounded-l-none border-b-2 border-" +
                        color +
                        "-500"
                        : "text-indigo-50 bg-indigo-300 border-b-2 rounded rounded-l-none border-indigo-300")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenUpperTab(2);
                    }}
                    data-toggle="tab"
                    href="#link2"
                    role="tablist"
                  >
                    <i className="fas fa-cog text-base mr-1"></i> Information
                  </a>
                </li>
              </ul>
              <div className="relative flex flex-col min-w-0 break-words  w-full mb-2">
                <div>
                  <div className="tab-content tab-space">
                    <div
                      className={
                        openUpperTab === 1 ? "flex flex-col" : "hidden"
                      }
                      id="link1"
                    >
                      <div className="pb-5 px-0 pr-10 flex flex-wrap  w-full">
                        {/* insurance table */}
                        <div className="w-full">
                          {(!loaders.storedProduct.fetchingLoaders &&
                            products?.length < 1) |
                            loaders.storedProduct.fetchFailedMessage ? (
                            <div
                              className={
                                !loaders.storedProduct.fetchFailedMessage
                                  ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                                  : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                              }
                            >
                              <p className="m-auto">
                                {!loaders.storedProduct.fetchFailedMessage
                                  ? "No product  in stock"
                                  : loaders.storedProduct.fetchFailedMessage}
                              </p>
                            </div>
                          ) : (
                            <Table
                              data={
                                loaders.storedProduct.fetchingLoaders
                                  ? loadingStoredProducts
                                  : loadedItems
                              }
                              columns={columns}
                            />
                          )}{" "}
                        </div>
                      </div>
                    </div>
                    {/* Stocks table */}
                    <div
                      className={
                        openUpperTab === 2 ? "flex flex-col" : "hidden"
                      }
                      id="link1"
                    >
                      <div className="pb-5 px-0 flex flex-wrap  w-full">
                        {/* Academics table */}
                        <div className="w-full flex flex-col my-3 ml-10 mr-10 border">
                          <div className="flex flex-col md:flex-row border-b p-5">
                            <div className="font-semibold md:w-2/12">Owner</div>
                            <div>{stock.stockOwner}</div>
                          </div>
                          <div className="flex flex-col md:flex-row  p-5">
                            <div className="font-semibold md:w-2/12">
                              Description
                            </div>
                            <div className="text-justify md:w-8/12">
                              {stock.description}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* end.... */}
          <div
            className={
              addProductOverlay | editProductOverlay
                ? "flex w-screen"
                : "hidden"
            }
          >
            <Overlay>
              <div className=" bg-white m-auto  rounded">
                <div
                  className={
                    loaders.storedProduct.message
                      ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                      : "hidden"
                  }
                >
                  <p>{loaders.storedProduct.message}</p>
                </div>
                <div className="p-10">
                  <div className="flex">
                    <h2 className="font-semibold  w-80">
                      {addProductOverlay
                        ? "Register property"
                        : "Change property info"}
                    </h2>
                    <div className="m-auto mr-0">
                      <button
                        className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                        onClick={() => {
                          addProductOverlay
                            ? productOverlayController()
                            : editProductOverlayController({
                              id: "",
                              amount: "",
                              amountQuantityMeasurement: "",
                              expireDate: "",
                              status: "STORED",
                              stockTypesIds: [{ idValue: selectedStoreId }],
                              storedAt: "",
                              storedToolName: "",
                            });
                        }}
                      >
                        <IoCloseOutline className="text-white" />{" "}
                      </button>
                    </div>
                  </div>{" "}
                  <form
                    className="flex flex-wrap"
                    onSubmit={handleProductSubmit}
                  >
                    <div className="w-full">
                      <div className="flex flex-col pt-3">
                        {/*  field */}
                        <div className="py-2 w-full">
                          <label>Name </label>
                          <div className={style.field.parentDiv}>
                            <input
                              type="text"
                              className={style.field.input}
                              value={product.storedToolName}
                              onChange={(e) =>
                                setProduct({
                                  ...product,
                                  storedToolName: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        {/*  field */}
                        <div className="py-2 w-full">
                          <div className="flex">
                            <div>
                              <label>Amount </label>

                              <div
                                className={
                                  style.field.parentDiv + " mr-2 w-1/2"
                                }
                              >
                                <input
                                  type="number"
                                  className={style.field.input}
                                  value={product.amount}
                                  onChange={(e) =>
                                    setProduct({
                                      ...product,
                                      amount: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="ml-2">
                              <label>Quantity </label>

                              <div className={style.field.parentDiv + "w-1/2"}>
                                <input
                                  type="text"
                                  className={style.field.input}
                                  value={product.amountQuantityMeasurement}
                                  onChange={(e) =>
                                    setProduct({
                                      ...product,
                                      amountQuantityMeasurement: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/*  field */}
                        <div className="py-2  w-full">
                          <div className="flex">
                            <div className="mr-2 w-1/2">
                              <label>Stored At</label>
                              <div className={style.field.parentDiv}>
                                <input
                                  type="date"
                                  className={style.field.input}
                                  value={product.storedAt}
                                  onChange={(e) =>
                                    setProduct({
                                      ...product,
                                      storedAt: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="mr-2 w-1/2">
                              <label> Expire Date</label>
                              <div className={style.field.parentDiv}>
                                <input
                                  type="date"
                                  className={style.field.input}
                                  value={product.expireDate}
                                  onChange={(e) =>
                                    setProduct({
                                      ...product,
                                      expireDate: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* save btn */}
                        <button
                          type="submit"
                          className={style.loginBtn}
                          disabled={loaders.storedProduct.sendingLoader}
                        >
                          {!loaders.storedProduct.sendingLoader ? (
                            <p className="m-auto">
                              {addProductOverlay ? "Save" : "Update"}
                            </p>
                          ) : (
                            <div className="spinner m-auto">
                              <div className="bounce1"></div>
                              <div className="bounce2"></div>
                              <div className="bounce3"></div>
                            </div>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Overlay>
          </div>
          {/*edit Stock overlay  */}
          <div className={addStock || editStock ? "flex w-screen" : "hidden"}>
            <Overlay>
              <div className="bg-white m-auto  rounded">
                <div
                  className={
                    loaders.store.message
                      ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                      : "hidden"
                  }
                >
                  <p>{loaders.store.message}</p>
                </div>
                <div className="p-10">
                  <div className="flex">
                    <h2 className="font-semibold  w-80">
                      {"Change stock info"}
                    </h2>
                    <div className="m-auto mr-0">
                      <button
                        className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                        onClick={() => {
                          addStock
                            ? AddStockController()
                            : editStockController(stock);
                        }}
                      >
                        <IoCloseOutline className="text-white" />{" "}
                      </button>
                    </div>
                  </div>{" "}
                  <form className="flex flex-wrap" onSubmit={handleStockUpdate}>
                    <div className="w-full">
                      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2">
                        <div>
                          <div className="flex flex-col pt-3">
                            {/*  field */}
                            <div className="py-2 w-full">
                              <label>Name </label>
                              <div className={style.field.parentDiv}>
                                <input
                                  type="text"
                                  className={style.field.input}
                                  value={editedStock.stockName}
                                  onChange={(e) =>
                                    setEditedStock({
                                      ...editedStock,
                                      stockName: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            {/*  field */}
                            <div className="py-2  w-full">
                              <label>Owner </label>
                              <Select
                                options={stocksOwnersOption}
                                value={stocksOwnersOption.filter((obj) =>
                                  selectedValue.includes(obj.value)
                                )}
                                onChange={handleChange}
                                isMulti
                                isClearable
                              />
                            </div>
                            {/*  field */}
                            <div className="py-2 w-full">
                              <label>Description </label>
                              <div className={style.field.parentDiv}>
                                <textarea
                                  className={style.field.input}
                                  value={editedStock.description}
                                  onChange={(e) =>
                                    setEditedStock({
                                      ...editedStock,
                                      description: e.target.value,
                                    })
                                  }
                                ></textarea>
                              </div>
                            </div>

                            {/* save btn */}
                            <button
                              type="submit"
                              className={style.loginBtn}
                              disabled={loaders.store.sendingLoader}
                            >
                              {!loaders.store.sendingLoader ? (
                                <p className="m-auto">{"Save"}</p>
                              ) : (
                                <div className="spinner m-auto">
                                  <div className="bounce1"></div>
                                  <div className="bounce2"></div>
                                  <div className="bounce3"></div>
                                </div>
                              )}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Overlay>
          </div>
          {/* filter insurance  overlay */}
          <div className={filterBenOverlay ? "flex w-screen" : "hidden"}>
            <Overlay>
              <div className="p-10 bg-white m-auto  rounded">
                <div className="flex">
                  <h2 className="font-semibold">{""}</h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        filterOverlayController();
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-col pt-3">
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Nomero</label>
                    <div className="flex w-full">
                      <Select options={beneficiaries} className="w-1/2 mr-2" />

                      <Select options={beneficiaries} className="w-1/2" />
                    </div>{" "}
                  </div>
                  {/*  field */}
                  <div className="py-2  w-full">
                    <label>Stati </label>
                    <Select options={Insurances} isMulti />
                  </div>

                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Igihe </label>
                    <div className="flex w-full">
                      <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                        <input
                          type="text"
                          className={style.field.input}
                          placeholder="Guhera"
                        />
                      </div>
                      <div className={style.field.parentDiv + " w-1/2"}>
                        <input
                          type="text"
                          className={style.field.input}
                          placeholder="Kugeza"
                        />
                      </div>
                    </div>
                  </div>

                  {/* save btn */}
                  <button type="submit" className={style.loginBtn}>
                    <p className="m-auto">{"Kuyungurura"}</p>
                  </button>
                </div>
              </div>
            </Overlay>
          </div>
          {/* filter Stocks  overlay */}
          <div className={filterStockOverlay ? "flex w-screen" : "hidden"}>
            <Overlay>
              <div className="p-10 bg-white m-auto  rounded">
                <div className="flex">
                  <h2 className="font-semibold">
                    {"Kuyungurura inkunga k`ubwishingizi"}
                  </h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        StockFilterOverlayController();
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-col pt-3">
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Nomero</label>
                    <div className="flex w-full">
                      <Select options={beneficiaries} className="w-1/2 mr-2" />

                      <Select options={beneficiaries} className="w-1/2" />
                    </div>{" "}
                  </div>
                  {/*  field */}
                  <div className="py-2  w-full">
                    <label>Uko ahagaze </label>
                    <Select options={Insurances} isMulti />
                  </div>

                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Igihe </label>
                    <div className="flex w-full">
                      <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                        <input
                          type="date"
                          className={style.field.input}
                          placeholder="Guhera"
                        />
                      </div>
                      <div className={style.field.parentDiv + " w-1/2"}>
                        <input
                          type="date"
                          className={style.field.input}
                          placeholder="Kugeza"
                        />
                      </div>
                    </div>
                  </div>
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Ayishyuwe </label>
                    <div className="flex w-full">
                      <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                        <input
                          type="text"
                          className={style.field.input}
                          placeholder="Akenewe"
                        />
                      </div>
                      <div className={style.field.parentDiv + " w-1/2"}>
                        <input
                          type="text"
                          className={style.field.input}
                          placeholder="Inkunga"
                        />
                      </div>
                    </div>
                  </div>
                  {/* save btn */}
                  <button type="submit" className={style.loginBtn}>
                    <p className="m-auto">{"Kuyungurura"}</p>
                  </button>
                </div>
              </div>
            </Overlay>
          </div>
        </div>
      )}

      <table className="table text-left table-to-export hidden" id="table-to-xls">
        <thead className="thead-dark">
          <tr>
            <th>Property</th>
            <th>Quantity</th>
            <th>StoredAt</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>

          {products.map((product) =>
            <tr>
              <td>{product.storedToolName}</td>
              <td>{product.amount} {product.storedToolName}</td>
              <td>{changeFromTimeStamp(product.storedAt)}</td>
              <td>{product.status}</td>
            </tr>
          )}
        </tbody>
      </table>

    </DashLayout>
  );
}

export default ViewStock;
